import React, { Component } from 'react';
import { Col, Row, Container, HeadingTwo, HeadingFour } from '../../legacy/hui/src/styled';
import { TitleBar } from './TitleBar';
import { JumbotronHero } from '../components/Install/JumbotronHero';
import icon from '../images/phone-new-message.svg';

const ErrorContainer = Container.extend`
  h2,
  h4,
  div,
  p {
    font-family: 'Roboto' !important;
  }

  h2,
  h4 {
    font-weight: 200;
  }
`;

export default class Error extends Component {
  render() {
    return (
      <React.Fragment>
        <TitleBar pageTitle={'Installation Service'} />
        <JumbotronHero />
        <ErrorContainer>
          <Row>
            <Col xs={12} center>
              <img src={icon} style={{ marginTop: 50 }} />
              <HeadingTwo style={{ marginTop: 30 }}>
                Oh dear, we&apos;re experiencing a brief outage
              </HeadingTwo>
              <HeadingFour style={{ marginTop: 30 }}>
                Don&apos;t worry it&apos;s not you, it&apos;s us. We&apos;re working hard to get
                things back to normal as soon as possible. Please try again later…
              </HeadingFour>
              <HeadingFour style={{ marginTop: 80 }}>
                You can still ring us to start a new job or get help with an existing one.
              </HeadingFour>
              <HeadingTwo style={{ marginTop: 20, marginBottom: 80 }}>1300 043 520</HeadingTwo>
            </Col>
          </Row>
        </ErrorContainer>
      </React.Fragment>
    );
  }
}
